import { DatePicker, Empty } from 'antd';
import Chart from 'chart.js/auto';
import 'chartjs-adapter-moment';
import moment from 'moment';
import PropTypes from 'prop-types';
import { useEffect, useRef, useState } from 'react';
import style from './ChartActivePower.module.scss';

export default function ChartActivePower(props) {
  const { date, setDate, newDataChartPAA, isReport, isExport } = props;
  const chartRef = useRef(null);
  const [chartInstance, setChartInstance] = useState(null);
  useEffect(() => {
    if (chartRef && chartRef.current && chartInstance == null) {
      const newChartInstance = new Chart(chartRef.current, chartConfig);
      setChartInstance(newChartInstance);
    }
  }, []);

  useEffect(() => {
    if (chartInstance) {
      console.log(
        'Log: ~ file: ChartActivePower.jsx ~ line 22 ~ useEffect ~ chartInstance',
        chartInstance
      );
      updateDataset(newDataChartPAA);
    }
  }, [newDataChartPAA]);

  const updateDataset = (listOne) => {
    if (listOne.value === 'irra') {
      chartInstance.options.scales = {
        x: {
          type: 'time',
          title: {
            display: false,
            text: 'Time',
            font: {
              // family: 'Times',
              size: isExport ? 8 : 14,
              style: 'normal',
            },
            color: !isReport ? '#666' : '#000',
          },
        },
        y: {
          title: {
            display: false,
            text: 'Total active power (kW)',
            font: {
              // family: 'Times',
              size: isExport ? 8 : 14,
              style: 'normal',
            },
            color: !isReport ? '#666' : '#000',
          },
          ticks: {
            callback: function (value, index, values) {
              return `${value} kW`;
            },
            font: {
              // family: 'Times',
              size: isExport ? 8 : 14,
              style: 'normal',
            },
            color: !isReport ? '#666' : '#000',
          },
        },
      };
    } else {
      chartInstance.options.scales = {
        x: {
          type: 'time',
          title: {
            display: false,
            text: 'Time',
            font: {
              // family: 'Times',
              size: isExport ? 8 : 14,
              style: 'normal',
            },
            color: !isReport ? '#666' : '#000',
          },
        },
        y: {
          title: {
            display: false,
            text: 'Total active power (kW)',
            font: {
              // family: 'Times',
              size: isExport ? 8 : 14,
              style: 'normal',
            },
            color: !isReport ? '#666' : '#000',
          },
          ticks: {
            callback: function (value, index, values) {
              return `${value} kW`;
            },
            font: {
              // family: 'Times',
              size: isExport ? 8 : 14,
              style: 'normal',
            },
            color: !isReport ? '#666' : '#000',
          },
        },
        y1: {
          type: 'linear',
          display: true,
          position: 'right',
          title: {
            display: false,
            text: 'Solar Irradiance W/m2',
            // color: '#fcc603',
            font: {
              // family: 'Times',
              size: isExport ? 8 : 14,
              style: 'normal',
              lineHeight: 1.2,
            },
            color: !isReport ? '#666' : '#000',
          },
          ticks: {
            // Include a dollar sign in the ticks
            callback: function (value, index, values) {
              return `${value} W/m2`;
            },
            font: {
              // family: 'Times',
              size: isExport ? 8 : 14,
              style: 'normal',
            },
            color: !isReport ? '#666' : '#000',
          },
          grid: {
            drawOnChartArea: false, // only want the grid lines for one axis to show up
          },
          min: 0,
        },
      };
    }
    chartInstance.data.datasets = installDataset(listOne);
    chartInstance.update();
  };

  const installDataset = (listOne) => {
    let newList;
    if (listOne.value === 'irra') {
      newList = [
        {
          type: 'line',
          unit: 'kW',
          label: 'Total active power',
          data: listOne.data,
          parsing: {
            yAxisKey: 'power',
            xAxisKey: 'ts',
          },
          borderColor: '#038cfc',
          borderWidth: 1,
          backgroundColor: '#038cfc',
          fill: true,
        },
      ];
    } else {
      newList = [
        {
          type: 'line',
          unit: 'W/m2',
          label: 'Solar Irradiance',
          data: listOne.data,
          parsing: {
            yAxisKey: 'irra',
            xAxisKey: 'ts',
          },
          backgroundColor: '#ff3c2e',
          borderColor: '#ff3c2e',
          borderWidth: 2,
          yAxisID: 'y1',
        },
        {
          type: 'line',
          unit: 'kW',
          label: 'Total active power',
          data: listOne.data,
          parsing: {
            yAxisKey: 'power',
            xAxisKey: 'ts',
          },
          borderColor: '#038cfc',
          borderWidth: 1,
          backgroundColor: '#038cfc',
          fill: true,
        },
      ];
    }
    return newList;
  };

  const data = {
    datasets: [
      {
        type: 'line',
        unit: 'W/m2',
        label: 'Solar Irradiance',
        data: newDataChartPAA.data,
        parsing: {
          yAxisKey: 'irra',
          xAxisKey: 'ts',
        },
        backgroundColor: '#ff3c2e',
        borderColor: '#ff3c2e',
        borderWidth: 2,
        yAxisID: 'y1',
      },
      {
        type: 'line',
        unit: 'kW',
        label: 'Total active power',
        data: newDataChartPAA.data,
        parsing: {
          yAxisKey: 'power',
          xAxisKey: 'ts',
        },
        borderColor: '#038cfc',
        borderWidth: 1,
        backgroundColor: '#038cfc',
        fill: true,
      },
    ],
  };

  const chartConfig = {
    data: data,
    options: {
      elements: {
        point: {
          radius: 0,
        },
        line: {
          tension: 0.3,
        },
      },
      interaction: {
        mode: 'nearest',
        axis: 'x',
        intersect: false,
      },
      maintainAspectRatio: false,
      plugins: {
        title: {
          text: 'Chart.js Time Scale',
          display: false,
        },
        legend: {
          display: true,
          labels: {
            font: {
              size: isExport ? 8 : 14,
            },
            color: !isReport ? '#666' : '#000',
          },
        },
        tooltip: {
          callbacks: {
            label: function (context) {
              var label = context.dataset.label || '';
              var unit = context.dataset.unit;
              if (label) {
                label += ': ';
              }
              if (context.parsed.y !== null) {
                label += `${context.parsed.y} ${unit}`;
              }
              return label;
            },
          },
        },
      },
      scales: {
        x: {
          type: 'time',
          title: {
            display: false,
            text: 'Time',
            font: {
              // family: 'Times',
              size: isExport ? 8 : 12,
              style: 'normal',
            },
            color: !isReport ? '#666' : '#000',
          },
          ticks: {
            font: {
              // family: 'Times',
              size: isExport ? 8 : 12,
              style: 'normal',
            },
            color: !isReport ? '#666' : '#000',
          },
        },
        y: {
          title: {
            display: false,
            text: 'Total active power (kW)',
            font: {
              // family: 'Times',
              size: isExport ? 8 : 12,
              style: 'normal',
              lineHeight: 1.2,
            },
            color: !isReport ? '#666' : '#000',
          },
          ticks: {
            callback: function (value, index, values) {
              return `${value} kW`;
            },
            font: {
              // family: 'Times',
              size: isExport ? 8 : 14,
              style: 'normal',
            },
            color: !isReport ? '#666' : '#000',
          },
        },
        y1: {
          type: 'linear',
          display: true,
          position: 'right',
          title: {
            display: false,
            text: 'Solar Irradiance W/m2',
            // color: '#fcc603',
            font: {
              // family: 'Times',
              size: isExport ? 8 : 12,
              style: 'normal',
              lineHeight: 1.2,
            },
            color: !isReport ? '#666' : '#000',
          },
          ticks: {
            // Include a dollar sign in the ticks
            callback: function (value, index, values) {
              return `${value} W/m2`;
            },
            font: {
              // family: 'Times',
              size: isExport ? 8 : 12,
              style: 'normal',
            },
            color: !isReport ? '#666' : '#000',
          },
          grid: {
            drawOnChartArea: false, // only want the grid lines for one axis to show up
          },
          min: 0,
        },
      },
    },
  };

  return (
    <>
      {isReport ? (
        <div className={style.chart_report}>
          {newDataChartPAA !== null ? <canvas ref={chartRef} /> : <Empty />}
        </div>
      ) : (
        <div className={style.chart}>
          {newDataChartPAA !== null ? <canvas ref={chartRef} /> : <Empty />}
        </div>
      )}
    </>
  );
}
ChartActivePower.propTypes = {
  isExport: PropTypes.bool,
  isReport: PropTypes.bool,
  setDate: PropTypes.func,
  date: PropTypes.string,
  newDataChartPAA: PropTypes.shape({
    data: PropTypes.arrayOf(
      PropTypes.shape({
        ts: PropTypes.number.isRequired,
        power: PropTypes.number,
        irra: PropTypes.number,
        temp: PropTypes.number,
      })
    ),
    value: PropTypes.string.isRequired,
  }),
};
